import { Html } from "@react-three/drei";

const Utility = (props) => {
  return (
    <>
      <Html className="page" {...props} fullscreen zIndexRange={[0, 0]}>
        {props.visible ? (
          <>
            <h1 className="title">VERSATILE UTILITY</h1>
            <p className="text">
              With up to 3,500 pounds of payload capacity and adjustable air
              suspension, Cybertruck is the most powerful tool we have ever
              built, engineered with 100 cubic feet of exterior, lockable
              storage — including a magic tonneau cover that is strong enough to
              stand on.
            </p>
          </>
        ) : null}
      </Html>
    </>
  );
};

export default Utility;
